import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => ({
  homePage: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '20px',
    height: '100%',
  },
  homePageTile: {
    display: 'flex',
    maxWidth: '40vw',
    // background: theme.palette.background.paper,
    background: '#f5f9ff',
    padding: '30px',
    borderRadius: '15px',
    gap: '20px',
    '& svg': { width: '300px', height: '300px' },
    '& h1': { fontWeight: 500, fontSize: '20px', color: '#000000' },
    '& p': {
      fontSize: '15px',
      lineHeight: '20px',
      color: 'rgba(129, 129, 129, 0.72)',
      textWrap: 'normal',
    },
  },
}));

export default useStyles;
